var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import styled from 'styled-components';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import { EGamePhase, getPhaseEventDescription, } from '../../../../types';
import { setMatchDay, setMatchNight } from '../../../../api';
import { selectMatchState, setMatchState } from '../../../../store/match';
import { useAppDispatch, useAppSelector } from '../../../../hooks';
import { useErrorHandler } from '../../../../hooks/useErrorHandler';
import { DeskPool } from '../../DeskPool';
import { ModalNew } from '../../../atoms/Modal/Modal';
import { Delimiter } from '../../../atoms/Delimiter';
const eventStyles = {
    padding: '40px 48px',
    display: 'flex',
    justifyContent: 'space-between',
    width: '534px',
    alignContent: 'baseline',
};
const Container = styled.div `
  display: flex;
  align-items: center;
`;
export function ShowPhaseEvents({ useCase }) {
    const { errorHandler } = useErrorHandler();
    const dispatch = useAppDispatch();
    const matchState = useAppSelector(selectMatchState);
    const events = useMemo(() => (matchState === null || matchState === void 0 ? void 0 : matchState.state).events || [], [matchState]);
    const matchStateId = (matchState === null || matchState === void 0 ? void 0 : matchState.id) || '';
    const incrementIndex = () => __awaiter(this, void 0, void 0, function* () {
        try {
            const result = useCase === EGamePhase.DAY ? yield setMatchNight(matchStateId) : yield setMatchDay(matchStateId);
            dispatch(setMatchState(result));
        }
        catch (err) {
            errorHandler(err);
        }
    });
    const buttonText = useCase === EGamePhase.DAY ? 'Город засыпает' : 'Начать голосование';
    const renderEvent = (event) => {
        const eventDesc = getPhaseEventDescription(event.type);
        return (_jsxs(Paper, Object.assign({ sx: eventStyles }, { children: [_jsx(Container, { children: _jsxs("div", { children: [_jsx(Typography, Object.assign({ variant: "h4" }, { children: event.player.gameName })), _jsx(Delimiter, { top: "12px" }), _jsx(Typography, Object.assign({ variant: "subtitle2" }, { children: event.player.realName }))] }) }), _jsx(Typography, Object.assign({ sx: { color: '#cc8181' }, variant: "h4" }, { children: eventDesc.name }))] }), event.id));
    };
    const renderNoEvents = () => (_jsx(Paper, Object.assign({ sx: eventStyles }, { children: _jsx(Typography, Object.assign({ variant: "h4" }, { children: "\u0421\u043C\u0435\u0440\u0442\u0435\u0439 \u043D\u0435\u0442" })) })));
    // eslint-disable-next-line react/no-unstable-nested-components
    function PhaseEventModal() {
        if (events.length) {
            return (_jsx(ModalNew, Object.assign({ eventModal: true, onClose: () => null }, { children: events.map((event) => renderEvent(event)) })));
        }
        return (_jsx(ModalNew, Object.assign({ eventModal: true, onClose: () => null }, { children: renderNoEvents() })));
    }
    const onPlayerClickAction = null;
    const gameButtonState = {
        text: buttonText,
        visible: true,
        onClick: incrementIndex,
    };
    return (_jsx(DeskPool, { onPlayerClickAction: onPlayerClickAction, gameButtonState: gameButtonState, addOnComponent: () => PhaseEventModal() }));
}
